export interface Business {
  id: string;
  name: string;
  description: string;
  address: string;
  city: string;
  state: string;
  region?: string;
  category: string;
  tags: string[];
  rating: number;
  imageUrl: string;
  website?: string;
  phone?: string;
  email?: string;
  media_urls?: string[];
  hours?: {
    [key: string]: {
      open: string;
      close: string;
    };
  };
  features?: string[];
  certifications?: string[];
  facebook?: string;
  instagram?: string;
  tiktok?: string;
  postcode?: string;
  what3words?: string;
}

export type BusinessCategory = 
  | "restaurant"
  | "shop"
  | "market"
  | "cafe"
  | "service"
  | "event"
  | "farm"
  | "accommodation"
  | "organisation"
  | "wellness";

export const CATEGORY_LABELS: Record<string, string> = {
  restaurant: "Restaurants",
  shop: "Eco Shops",
  market: "Farmers Markets",
  cafe: "Cafes",
  service: "Services",
  event: "Events",
  farm: "Farms",
  accommodation: "Accommodations",
  organisation: "Organisations",
  wellness: "Wellness"
};

export interface BusinessListingFilters {
  searchTerm?: string;
  category?: BusinessCategory;
  tags?: string[];
  city?: string;
}

export interface Event {
  id: string;
  title: string;
  description?: string;
  start_date: string;
  end_date: string;
  location?: string;
  organizer?: string;
  image_url?: string;
  website?: string;
  category?: string;
  created_at: string;
  updated_at: string;
}

export interface EventSubmission {
  title: string;
  description?: string;
  start_date: Date;
  end_date: Date;
  location?: string;
  organizer?: string;
  image_url?: string;
  website?: string;
  category?: string;
}
